// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCheckOutlinedSvg from "@fishx/icons-svg/es/asn/PtoCheckOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoCheckOutlined = function PtoCheckOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCheckOutlinedSvg
  }));
};

PtoCheckOutlined.displayName = 'PtoCheckOutlined';
export default React.forwardRef(PtoCheckOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCheckOutlined.js
// module id = 3884
// module chunks = 0